/**
 * Iter 68 — Colour palette for the "Type" chip across browse / car-detail /
 * vendor rate / bulk-edit surfaces.
 *
 * We pick one Tailwind colour family per type so the same chip is instantly
 * recognisable at a glance, no matter where it appears. Pastels with bold
 * text so readability stays high against the white card body.
 *
 * Unknown / null types fall through to a neutral slate so the chip still
 * renders cleanly when a car record is missing the field.
 */

// Exported as a plain `{className, label}` shape so callers can drop straight
// into a span/div without further branching.
const TYPE_STYLES = {
  // Small / city
  "Economy":            "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Compact":            "bg-teal-100 text-teal-800 border-teal-200",
  "Hatchback":          "bg-cyan-100 text-cyan-800 border-cyan-200",
  // Mid / family
  "Sedan":              "bg-sky-100 text-sky-800 border-sky-200",
  "Wagon / Estate":     "bg-blue-100 text-blue-800 border-blue-200",
  "Coupe":              "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Convertible":        "bg-pink-100 text-pink-800 border-pink-200",
  // SUV family
  "SUV":                "bg-orange-100 text-orange-800 border-orange-200",
  "SUV 4x4":            "bg-amber-100 text-amber-900 border-amber-200",
  // Vans / family
  "MPV / Family Vans":  "bg-yellow-100 text-yellow-900 border-yellow-200",
  "Minivan":            "bg-lime-100 text-lime-800 border-lime-200",
  "Van":                "bg-green-100 text-green-800 border-green-200",
  // Utility
  "Pickup Trucks":      "bg-stone-200 text-stone-800 border-stone-300",
  "Truck":              "bg-zinc-200 text-zinc-800 border-zinc-300",
  // Premium / electric
  "Luxury":             "bg-purple-100 text-purple-900 border-purple-200",
  "Electric & Hybrid":  "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
};

const FALLBACK = "bg-slate-100 text-slate-700 border-slate-200";

/**
 * Returns the Tailwind class string for the given car type. Always safe to
 * call — never throws, falls back to a neutral slate chip when the type is
 * unknown or empty.
 */
export function carTypeBadgeClass(carType) {
  if (!carType) return FALLBACK;
  return TYPE_STYLES[carType] || FALLBACK;
}

export const CAR_TYPE_STYLES = TYPE_STYLES;
